module.exports = __webpack_public_path__ + "img/distributionBoardSchemaImages-example.a00007e9.jpg";